module.exports = __webpack_public_path__ + "static/loda-sm-9e1279927d9bb339d396e5aa85cfed49.jpg";